<template>
  <div class="similar-courses">
    <Slider :disabled="filteredCourses.length <= 2">
      <h3 slot="heading" class="section-title h3">
        <SimilarCoursesIcon v-if="icon" />{{ title }}
      </h3>
      <CourseCard
        v-for="course in filteredCourses"
        :key="course.id"
        slot="slide"
        :course="course"
        class="col col-6 sm-6"
        :url-mode="$store.getters['auth/user'].role === 'business-admin' && $route.name === 'business-library-slug' ? 'library' : 'course'"
        heading="h4"
      >
        <nuxt-link
          v-if="$store.getters['auth/user'].role === 'business-admin' && $route.name === 'business-library-slug' && course.status !== 'locked' && course.unlocked"
          slot="business"
          :to="`/business/tasks/new/?course=${course.id}`" class="btn-link-accent"
        >
          Assign
        </nuxt-link>
      </CourseCard>
    </Slider>
  </div>
</template>
<script>
import Slider from '../../components/Slider';
import CourseCard from '../Card';
import SimilarCoursesIcon from '../../assets/svg/courses/similar-courses-icon.svg?vue-component';

export default {
  components: { Slider, CourseCard, SimilarCoursesIcon },
  props: {
    icon: { type: Boolean },
    title: { type: String, default: '' },
    courses: { type: Array, default: () => [], required: true },
  },
  computed: {
    filteredCourses() {
      if (this.$store.state.layout === 'mobile') {
        return this.courses.slice(0, 3);
      }

      return this.courses;
    },
  },
};
</script>

<style lang="scss" scoped>
.similar-courses {
  .h3 {
    margin: 0;
  }

  .btn-link-accent {
    display: inline-block;
    color: var(--accent-shade-1);
  }
}
</style>
